<template>
  <section className="w-full h-full flex items-center justify-center">
    <aside
      className=" w-full lg:w-[80%] lg:py-2 lg:my-12 xl:my-8 py-2 md:py-5  flex flex-col lg:flex-row justify-center items-center bg-white rounded-2xl"
    >
      <div className="w-full h-full flex items-center justify-center ">
        <aside className="w-[95%] h-[95%] bg-[#d0df44] rounded-lg my-1">
          <img src="login-bg.png" alt="broken-img" />
        </aside>
      </div>
      <div
        className=" w-full h-full px-4 lg:px-0 flex items-center justify-center  "
      >
        <aside className="flex flex-col w-full h-full rounded-lg ">
          <div
            className="w-full flex flex-col justify-center items-center pt-2 "
          >
            <h1 className="font-semibold text-3xl">Welcome Back</h1>
            <p className="text-gray-400">to</p>
            <h1
              className="text-transparent bg-clip-text bg-gradient-to-r from-indigo-500 via-purple-500 to-pink-500 text-3xl md:text-3xl font-semibold"
            >
              Meal Planner
            </h1>
          </div>
          <div
            className="w-full flex flex-col justify-center items-center gap-2"
          >
            <aside
              className="w-full flex flex-col justify-start items-start gap-1"
            >
              <label>Username</label>
              <input
                type="text"
                placeholder="Enter Username"
                v-model="name"
                className="pl-4 w-[97%] border border-blue-400 outline-none py-3 rounded-md"
              />
            </aside>
            <aside
              className="w-full flex flex-col justify-start items-start gap-1"
            >
              <label>Email</label>
              <input
                type="text"
                placeholder="Enter Email"
                v-model="email"
                className="pl-4 w-[97%] border border-blue-400 outline-none py-3 rounded-md"
              />
            </aside>

            <aside
              className="w-full flex flex-col justify-start items-start gap-1"
            >
              <label>Password</label>
              <input
                type="text"
                placeholder="Enter Password"
                v-model="password"
                className="pl-4 w-[97%] border border-blue-400 outline-none py-3 rounded-md"
              />
            </aside>
            <button
              className="hover:bg-blue-800 cursor-pointer mt-4 w-[85%] bg-blue-500 rounded-full text-white shadow-[rgba(50,_50,_105,_0.15)_0px_2px_5px_0px,_rgba(0,_0,_0,_0.05)_0px_1px_1px_0px] h-12 flex items-center justify-center"
              @click="register"
            >
              Register
            </button>
          </div>
        </aside>
      </div>
    </aside>
  </section>
</template>

<script>
import { useToast } from 'vue-toastification';

export default {
  data() {
    return {
      name: '',
      email: '',
      password: ''
    };
  },
  setup() {
    const toast = useToast();
    return { toast };
  },
  methods: {
    async register() {
      try {
        const response = await fetch(
          'https://dashboard-backend-rtln.onrender.com/user/register',
          {
            method: 'POST',
            headers: {
              'Content-Type': 'application/json'
            },
            body: JSON.stringify({
              name: this.name,
              email: this.email,
              password: this.password
            })
          }
        );
        if (!response.ok) {
          throw new Error('Network response was not ok');
        }
        const data = await response.json();
        console.log('data>>>>', data);
        this.toast.success('Registration successful!', {
          position: 'top-right',
          timeout: 5000
        });
        this.$router.push('/');
      } catch (error) {
        this.toast.error('Registration failed: ' + error.message, {
          position: 'top-right',
          timeout: 5000
        });
      }
    }
  }
};
</script>
